module.exports = __webpack_public_path__ + "img/truck-is-driving-bridge-sunset.198ab44a.jpg";